export const noti = {
    text1: "Notificaciones",
    text2: "Listado de las notificaciones.",
    text3: "No tienes notificaciones",
};